import { PlatformComponentProps } from "@b2bportal/core-types";
import { IContactInfo } from "@b2bportal/core-types";
import { ControllerRenderProps } from "react-hook-form";

export interface PhoneNumberProps
  extends PlatformComponentProps,
    ControllerRenderProps<IContactInfo, "phoneNumber"> {
  error?: boolean;
  placeholder?: string;
  defaultValue?: string;
}

export const PhoneNumber = (props: PhoneNumberProps) => {
  const { className, placeholder, onChange, ...field } = props;
  return (
    <input
      {...field}
      className={className}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
};
